module.exports = __webpack_public_path__ + "static/img/davis_pictgrid42_960x856.cddbda0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/davis_pictgrid42_960x856.jpg
// module id = 7ztR
// module chunks = 0